// extracted by mini-css-extract-plugin
export var actionIcon = "PostListItem-module--actionIcon--DHXUA";
export var link = "PostListItem-module--link--PaZhz";
export var title = "PostListItem-module--title--0ckdK";